<template>
<v-flex class="champion" v-if="isSectionVisible">
    <v-flex tag="h2">{{memberProfileConstants.YPO_CHAMPION_POSITIONS}}
        <v-flex tag="em" v-if="isSeeAllVisible" data-qe-id="see-champions-role" @click="seeAllChampions()">{{isEnabled}}</v-flex>
    </v-flex>
    <status-overlay :action="loadGetChampionPositionsAction" content-height="240px">
    </status-overlay>
    <v-layout row wrap>
        <v-flex xs12 sm6 v-if="current.length != 0">
        <v-flex tag="h6">{{memberProfileConstants.CURRENT}} ({{current.length}})</v-flex>
            <v-flex v-if="!enabled">
                <v-flex class="champion__row" v-for="(positionCategory, index) in current.slice(0,1)" :key="index">
                    <img :src="memberProfileConstants.YPO_IMAGE_URL">
                    <v-flex tag="strong" v-if="positionCategory.eventName">{{positionCategory.eventName}}</v-flex>
                    <v-flex tag="strong" v-else>{{positionCategory.communityName}}</v-flex>
                    <v-flex tag="span">{{positionCategory.positionTitle}}</v-flex>
                    <v-flex tag="div">{{positionCategory.roleDescription}}</v-flex>
                    <v-flex tag="div">{{positionCategory.startDate}}</v-flex>
                </v-flex>
            </v-flex>
            <v-flex v-if="enabled">
                <v-flex class="champion__row" v-for="(positionCategory, index) in current" :key="index">
                    <img :src="memberProfileConstants.YPO_IMAGE_URL">
                    <v-flex tag="strong" v-if="positionCategory.eventName">{{positionCategory.eventName}}</v-flex>
                    <v-flex tag="strong" v-else>{{positionCategory.communityName}}</v-flex>
                    <v-flex tag="span">{{positionCategory.positionTitle}}</v-flex>
                    <v-flex tag="div">{{positionCategory.roleDescription}}</v-flex>
                    <v-flex tag="div">{{positionCategory.startDate}}</v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex xs12 sm6 v-if="previous.length != 0">
            <v-flex tag="h6">{{memberProfileConstants.PREVIOUS}} ({{previous.length}})</v-flex>
            <v-flex v-if="!enabled">
                <v-flex class="champion__row" v-for="(positionCategory, index) in previous.slice(0,1)" :key="index">
                    <img :src="memberProfileConstants.YPO_IMAGE_URL">
                    <v-flex tag="strong" v-if="positionCategory.eventName">{{positionCategory.eventName}}</v-flex>
                    <v-flex tag="strong" v-else>{{positionCategory.communityName}}</v-flex>
                    <v-flex tag="span">{{positionCategory.positionTitle}}</v-flex>
                    <v-flex tag="div">{{positionCategory.roleDescription}}</v-flex>
                    <v-flex tag="div">{{positionCategory.startDate}}</v-flex>
                </v-flex>
            </v-flex>
            <v-flex v-if="enabled">
                <v-flex class="champion__row" v-for="(positionCategory, index) in previous" :key="index">
                    <img :src="memberProfileConstants.YPO_IMAGE_URL">
                    <v-flex tag="strong" v-if="positionCategory.eventName">{{positionCategory.eventName}}</v-flex>
                    <v-flex tag="strong" v-else>{{positionCategory.communityName}}</v-flex>
                    <v-flex tag="span">{{positionCategory.positionTitle}}</v-flex>
                    <v-flex tag="div">{{positionCategory.roleDescription}}</v-flex>
                    <v-flex tag="div">{{positionCategory.startDate}}</v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
    </v-layout>
</v-flex>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { memberProfileConstants } from "./memberProfile.constants.js";
import StatusOverlay from '../StatusOverlay/StatusOverlay';

export default {
    name: "ChampionPosition",
    data: () => ({
        memberProfileConstants,
        enabled: false,
        championCurrentList: [],
        championPreviousList: [],
    }),
    components: {
        StatusOverlay,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
        this.getChampionPositions(this.memberId);
    },
    methods: {
        ...mapActions({
            getChampionPositions: `memberProfile/${storeAction.getChampionPositions}`,
        }),
        seeAllChampions() {
            this.enabled = !this.enabled;
        },
        getYear(startdate, enddate, positionTitle) {
            let date = '';
            const currentDate = new Date();
            const startDate = new Date(startdate);
            const endDate = new Date(enddate);
            if (startdate && endDate > currentDate && positionTitle === memberProfileConstants.CHAPTER_ADMIN) {
                date = `${startDate.getFullYear().toString()} - ${this.memberProfileConstants.PRESENT}`;
            } else if (startdate && enddate) {
                date = `${startDate.getFullYear().toString()} - ${endDate.getFullYear().toString()}`;
            } else if (!enddate && startdate) {
                date = startDate.getFullYear();
            }
            return date;
        },
    },
    computed: {
        ...mapGetters({
            championPositions: `memberProfile/${storeGetters.championPositions}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
        }),
        ...mapState("actionState", ["actions"]),
        isSectionVisible() {
            return this.current.length > 0 || this.previous.length > 0;
        },
        isSeeAllVisible() {
            return this.current.length > 1 || this.previous.length > 1;
        },
        isEnabled() {
            return this.enabled ?
                memberProfileConstants.SEE_LESS :
                memberProfileConstants.SEE_ALL;
        },
        current() {
            const localCurrentList = [];
            if (this.championPositions) {
                const currentList = this.championPositions.Current;
                currentList.forEach((x) => {
                    x.startDate = this.getYear(x.startDate, x.endDate, x.positionTitle);
                    localCurrentList.push(x);
                });
            }
            return localCurrentList;
        },
        previous() {
            const localPreviousList = [];
            if (this.championPositions) {
                const pastList = this.championPositions.Past;
                pastList.forEach((x) => {
                    x.startDate = this.getYear(x.startDate, x.endDate, x.positionTitle);
                    localPreviousList.push(x);
                });
            }
            return localPreviousList;
        },
        isCurrentUser() {
            return this.memberId === this.currentUserId;
        },
        loadGetChampionPositionsAction() {
            return this.actions[storeAction.getChampionPositions];
        }, 
    },
    watch: {
        current(currentData) {
            if (currentData) {
                this.championCurrentList = currentData;
            }
        },
        previous(previousData) {
            if (previousData) {
                this.championPreviousList = previousData;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.champion {
    position: relative;
    border-bottom: 1px solid $ypo-open-blue-gray;
    margin-top: 20px;
    padding: 0 20px 20px 20px;

    h6 {
        color: $ypo_blue;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 15px;
    }

    &__row {
        color: $ypo-dark-gray;
        font-size: 14px;
        line-height: 22px;
        position: relative;
        padding-left: 60px;
        margin: 10px 0 10px 0;

        img {
            max-width: 40px;
            position: absolute;
            left: 0;
            top: 0;
        }

        strong {
            display: block;
            color: $ypo-gray-text;
        }
    }

    @media (max-width: 1199px){
        padding: 0 0 20px 0;
    } 

    .overlay {
        top: 35px;
    }   
}

h2 {
    color: $ypo_blue;
    font-family: "Raleway", sans-serif;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 26px;

    span {
        color: $ypo-cta;

        font-size: 14px;
        font-weight: bold;
        line-height: 19px;
        cursor: pointer;
    }

    i {
        color: $ypo-dark-background-gray;
        font-size: 14px;
        position: relative;
        left: 5px;
        margin-right: 40px;
        cursor: pointer;
    }

    em {
        color: $ypo-cta;
        font-family: "Noto Sans";
        font-size: 14px;
        line-height: 24px;
        font-style: normal;
        margin-left: 10px;
        cursor: pointer;
    }
}
</style>
